import "./style.css";
import { initDashboard } from "./js/app.js";

initDashboard();

